import { ArticlePage } from '../../model/components/ArticlePage';
import { isLinkPage, LinkPostData } from '../../model/templates/LinkTemplate';
import { PathContextProvider } from '../../PathContext';
import { ArticlePageInput } from './ArticlePageInput';

import { assert } from '../../../utils/assert';

export interface LinkInputProps {
    value: LinkPostData;
    onChange?: (value: LinkPostData) => void;
}

export const LinkPostInput = ({ value, onChange }: LinkInputProps) => {
    const [frontPage] = value.pages;
    const onFrontPageChange = (page: ArticlePage) => {
        assert(isLinkPage(page), 'Button is not allowed to be undefined');

        onChange?.({
            ...value,
            pages: [page],
        });
    };

    return (
        <PathContextProvider segment="pages">
            <PathContextProvider segment={0}>
                <ArticlePageInput
                    value={frontPage}
                    onChange={onFrontPageChange}
                    pageIndex={0}
                    button={{
                        enabled: true,
                        allowedActions: [
                            'OpenLocation',
                            'OpenDistrict',
                            'OpenCharacterCreator',
                            'OpenOutfitDesigner',
                            'OpenCEX',
                            'OpenPortal',
                        ],
                    }}
                />
            </PathContextProvider>
        </PathContextProvider>
    );
};
